import { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import cursorImage from "../../../assets/images/footerLogo1.png"; // Replace with your image path
import { redDotCursor } from "../../../assets";


const CursorTrail = () => {
    const cursorRef = useRef(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener("resize", checkScreenSize);

        if (!isMobile) {
            const moveCursor = (e) => {
                gsap.to(cursorRef.current, {
                    x: e.clientX,
                    y: e.clientY,
                    duration: 0.2,
                    ease: "power2.out",
                });
            };

            window.addEventListener("mousemove", moveCursor);

            return () => {
                window.removeEventListener("mousemove", moveCursor);
                window.removeEventListener("resize", checkScreenSize);
            };
        }
    }, [isMobile]);

    if (isMobile) return null; // Hide cursor on mobile

    return (
        <div
            ref={cursorRef}
            className="custom-cursor"
            style={{
                position: "fixed",
                width: "20px",
                height: "20px",
                backgroundImage: `url(${redDotCursor})`,
                backgroundSize: "cover",
                pointerEvents: "none",
                transform: "translate(-50%, -50%)",
                zIndex: 9999999,
                // mixBlendMode: "difference",
            }}
        />
    );
};

export default CursorTrail;
